import { DATASOURCE } from 'Constants'

const initialState = {
  data: {},
  isTeams: true,
  loading: false,
  duration: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.DETAIL.KEY:
      return {
        ...state,
        isTeams: action.data.deployment.toLowerCase().startsWith("teams"),
        duration: action.data.durationMillis/1000,
        data: process(action.data),
        loading: false
      };
    case DATASOURCE.DETAIL.LOADING:
      return {
        ...state,
        isTeams: true,
        data: {},
        loading: true,
        duration: 0
      };
    default:
      return state;
  }
};

function process(data) {
  delete data.durationMillis;
  delete data.deployment;
  //  if (data.VTC && data.duration) {
  //    let durationS = 0;
  //    let times = data.duration.split(":");
  //    if (times.length === 3)
  //    {
  //      durationS += parseFloat(times[0])*60*60 + 
  //        parseFloat(times[1])*60 +
  //        parseFloat(times[2]);
  //    }
  //    if (data.deployment)
  //    {
  //      delete data.deployment;
  //    }
  //    if (durationS > 0)
  //    {
  //      let pIn = 0;
  //      let pOut = 0;
  //      Object.keys(data.VTC).forEach(key => {
  //        if (key.endsWith("In") && data.VTC[key].PacketLoss) {
  //          pIn += data.VTC[key].PacketLoss;
  //        } else if (key.endsWith("Out") && data.VTC[key].PacketLoss) {
  //          pOut += data.VTC[key].PacketLoss;
  //        }
  //      });
  //      if (pIn > 0 || pOut > 0) {
  //        data.VTC.packetLossPerSecondInbound = Math.round(pIn/durationS*100)/100;
  //        data.VTC.packetLossPerSecondOutbound = Math.round(pOut/durationS*100)/100;
  //      }
  //    }
  //  }
  return data;
};
